import React, { useEffect, useState, useCallback, useRef,useMemo } from 'react'; // Added useRef
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import html2pdf from 'html2pdf.js'; // Added html2pdf
import config from '../config/config';
import PaymentModal from "../components/PaymentModal";
import EditInvoiceModal from "../components/EditInvoiceModal";
import MUIDataTable from 'mui-datatables';
import { useNavigate } from 'react-router-dom';
import DynamicNav from "../config/dynamicNav"; 
import { 
  Typography, 
  Box, 
  CircularProgress,
  Paper,
  Grid,
  Chip,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Divider,
  Skeleton,
  IconButton,
  Alert,
  Snackbar,
  Tooltip,
  Badge,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Menu,
  MenuItem,
  useTheme
} from '@mui/material';
import { 
  ReceiptLong, 
  History, 
  FileDownload, 
  Print, 
  Mail, 
  Payment, 
  Check, 
  Warning, 
  ErrorOutline,
  InsertDriveFile,
  CalendarToday,
  ArrowUpward,
  ArrowDownward,
  FilterList
} from '@mui/icons-material';
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/SideBar";
import MoreVertIcon from '@mui/icons-material/MoreVert';

// Custom invoice status component with enhanced styling
const InvoiceStatus = ({ status }) => {
  const statusConfig = {
    paid: { color: 'success', icon: <Check fontSize="small" />, label: 'Paid' },
    pending: { color: 'warning', icon: <Warning fontSize="small" />, label: 'Pending' },
    overdue: { color: 'error', icon: <ErrorOutline fontSize="small" />, label: 'Overdue' },
    draft: { color: 'default', icon: <InsertDriveFile fontSize="small" />, label: 'Draft' },
  };

  

  const config = statusConfig[status.toLowerCase()] || statusConfig.pending;

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      color={config.color}
      size="small"
      sx={{
        borderRadius: '8px',
        transition: 'transform 0.2s ease',
        '&:hover': { transform: 'scale(1.05)' },
      }}
    />
  );
};

// Format currency values consistently
const formatCurrency = (amount, currency = 'USD') => {
 return new Intl.NumberFormat('en-KE', {
  style: 'currency',
  currency: 'KES',
  minimumFractionDigits: 2
}).format(amount);

};

// Format dates consistently
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  const options = { month: 'short', day: '2-digit', year: 'numeric' };
  return date.toLocaleDateString('en-US', options);
};

const StudentInvoicesLayout = () => {
  const { id, invoice_id } = useParams();
  
  const theme = useTheme();
  const [accounts, setAccounts] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [studentInfo, setStudentInfo] = useState(null);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  const [latestInvoice, setInvoiceLatest] = useState(null);
  const [previousInvoices, setPreviousInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [invoicesData, setInvoicesData] = useState([]);
  const [getInvoiceItems, setInvoiceItems] = useState([]);
  const [getEditInvoiceItems, setEditInvoiceItems] = useState([]);
  const [invoiceInfo, setInvoiceInfo] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentInputs, setPaymentInputs] = useState({});
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEditOpen, setEditModalOpen] = useState(false);
  const invoiceRef = useRef(null); // Added ref for invoice Paper
   const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const token = localStorage.getItem('token');
 const navigate = useNavigate();
  const handleMarkPaid = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);
  const handleEditModalClose = () => setEditModalOpen(false);

    const handleMenuClick = (event, student) => {
    event.stopPropagation(); // Prevents triggering onRowClick
    setAnchorEl(event.currentTarget);
    setSelectedStudent(student);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  

  const handleView = () => {
    setOpenModal(true);
    handleMenuClose();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Get the token from localStorage
  const getToken = () => localStorage.getItem('token');
  const token_ = getToken();
  // API base URL (use environment variable or fallback)
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || config.API_URL+'/api';

 const handleSubmitPayment = async (payload) => {
  try {
    //console.log("Payload received in handleSubmitPayment:", payload);
    const token = localStorage.getItem("token");

    // 1. Fetch CSRF cookie
    await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
      withCredentials: true,
    });

    // 2. Get CSRF token
    const xsrfToken = getCookie('XSRF-TOKEN');
    if (!xsrfToken) {
      throw new Error('CSRF token not found');
    }

    // 3. Send request
    const response = await axios.post(
      `${config.API_URL}/api/savePayments`,
      payload, // Use the payload directly
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        },
        withCredentials: true,
      }
    );

    const data = response.data;
   
    //window.location.assign(`/students/${payload.invoice_id}/invoices/${payload.invoice_id}`);
     window.location.assign(`/students/${payload.invoice_id}/viewinvoice`);
      setNotification({
      open: true,
      message: data.message || "Payment saved successfully.",
      severity: 'success',
    });
      return { success: true, message: data.message || "Payment saved successfully." };
  } catch (error) {
    console.error('Error in handleSubmitPayment:', error);
    setNotification({
      open: true,
      message: error.message || "Network error.",
      severity: 'error',
    });
    return { success: false, message: error.message || "Network error." };
  }
};

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  };




  const handleEditSubmitPayment = async (payload) => {
    try {
      const token = localStorage.getItem("token");

      // 1. Fetch CSRF cookie
      await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });

      // 2. Get CSRF token
      const xsrfToken = getCookie('XSRF-TOKEN');
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }

      // 3. Send the request with proper Content-Type and credentials
      const response = await fetch(`${config.API_URL}/api/saveInvoiceChanges`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-XSRF-TOKEN': xsrfToken,
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const text = await response.text();

      if (!response.ok) {
        let message = "Failed to save payment.";
        try {
          const json = JSON.parse(text);
          message = json.message || message;
        } catch (_) {
          if (text) message = text;
        }
        return { success: false, message };
      }

      // Parse only if response body exists
      const data = text ? JSON.parse(text) : {};
      window.location.assign(`/students/${payload.invoice_id}/viewinvoice`);
      return { success: true, message: data.message || "Payment saved successfully." };
    } catch (error) {
      console.error('Error in handleEditSubmitPayment:', error);
      return { success: false, message: error.message || "Network error." };
    }
  };

  





  const handleEditModal = async (item_id) => {
    setEditModalOpen(true);
    const token = localStorage.getItem("token");
    setLoading(true);
    try {
      const res = await api.get(config.API_URL+`/api/pullInvoiceItem/${item_id}`);
      setInvoiceItems(res.data.invoice_items);
    } catch (err) {
      console.error('Error fetching invoices:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // Create axios instance with auth headers
  const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });




  useEffect(() => {
    //get studentinvoice
    axios.get(config.API_URL+`/api/studentInvoice/${id}`, {
      headers: {
        Authorization: `Bearer ${token_}`
      }
    })
    .then(response => {
      setInvoiceInfo(response.data);
    })
    .catch(error => {
      console.error('Error fetching invoice info:', error);
    });

    axios.get(config.API_URL+`/api/latestInvoiceV2/${id}`, {
      headers: {
        Authorization: `Bearer ${token_}`
      }
    })
    .then(response => {
      setInvoiceLatest({
        id: response.data.id,
        customer_id: response.data.customer_id,
        invoiceNumber: response.data.invoiceNumber,
        invoiceIssueDate: response.data.invoiceIssueDate,
        invoiceDueDate: response.data.invoiceDueDate,
        invoiceAmount: response.data.invoiceAmount,
        status: response.data.status,
        raw: response.data.invoice,
      });
      setInvoiceItems(response.data.invoice_items);
      setPreviousInvoices(response.data.otherInvoices);
      setAccounts(response.data.accounts);
    })
    .catch(error => {
      console.error('Error fetching invoice info:', error);
    });
  }, [id]);

  // Add auth token to requests
  api.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );


  const fetchStudents = async (page = 0, rowsPerPage = 100, searchText = '') => {
    setLoading(true);
    

    try {
      const res = await axios.get(config.API_URL+'/api/pullpayments/'+id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: page + 1,
          per_page: rowsPerPage,
          search: searchText,
        },
      });

      setData(res.data.data);
      setTotal(res.data.total);
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
      setLoading(false);
    }
  };

  // Fetch student info
  const fetchStudentInfo = useCallback(async () => {
    try {
      const res = await api.get(`/studentInvoiceInfo/${id}`);
      setStudentInfo(res.data);
    } catch (err) {
      console.error('Error fetching student info:', err);
    }
  }, []);

  // Fetch invoices data
  const fetchInvoices = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await api.get(`/student/${id}/invoices`);
      setInvoicesData(res.data.data);
      processInvoicesData(res.data.data);
    } catch (err) {
      console.error('Error fetching invoices:', err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  // Mark invoice as paid
  const markAsPaid = async (invoiceId) => {
    try {
      await api.patch(`/invoices/${invoiceId}`, { status: 'paid' });
      setNotification({
        open: true,
        message: 'Invoice marked as paid successfully',
        severity: 'success'
      });
      fetchInvoices();
    } catch (err) {
      console.error('Failed to update invoice status:', err);
      setNotification({
        open: true,
        message: 'Failed to update invoice status',
        severity: 'error'
      });
    }
  };

  // Send invoice reminder
  const sendReminder = async (invoiceId) => {
    try {
      await api.post(`/invoices/${invoiceId}/send-reminder`);
      setNotification({
        open: true,
        message: 'Payment reminder sent successfully',
        severity: 'success'
      });
    } catch (err) {
      console.error('Failed to send payment reminder:', err);
      setNotification({
        open: true,
        message: 'Failed to send payment reminder',
        severity: 'error'
      });
    }
  };

  // Process invoices data based on sort configuration
  const processInvoicesData = useCallback((data) => {
    if (!data || data.length === 0) {
      //setLatestInvoice(null);
      //setPreviousInvoices([]);
      return;
    }
    
    const sortedInvoices = [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
    
    //setLatestInvoice(sortedInvoices[0]);
    //setPreviousInvoices(sortedInvoices.length > 1 ? sortedInvoices.slice(1) : []);
  }, [sortConfig]);

  const handleViewInvoice = (id, invoiceId) => {
    if (loading) return; // Prevent multiple requests
    setLoading(true);
    console.log(id);
    console.log(invoiceId);
    axios.get(config.API_URL+`/api/latestInvoice/${id}/${invoiceId}`, {
      headers: {
        Authorization: `Bearer ${token_}`
      }
    })
    .then(response => {
      setInvoiceLatest({
        invoiceNumber: response.data.invoiceNumber,
        invoiceIssueDate: response.data.invoiceIssueDate,
        invoiceDueDate: response.data.invoiceDueDate,
        invoiceAmount: response.data.invoiceAmount,
        status: response.data.status,
        raw: response.data.invoice,
      });
      setInvoiceItems(response.data.invoice_items);
      setPreviousInvoices(response.data.otherInvoices);
    })
    .catch(error => {
      console.error('Error fetching specific invoice info:', error);
    })
    .finally(() => {
      setLoading(false); // Always stop loading
    });
  };

  // Handle download invoice
  const handleDownloadInvoice = async (invoiceId) => {
    try {
      setNotification({ open: true, message: 'Invoice download started', severity: 'info' });
      const element = invoiceRef.current;
      if (!element) {
        throw new Error('Invoice element not found');
      }
      window.open(`${config.API_URL}/downloadInvoice/${id}/${token}`);
      /**await html2pdf()
        .set({
          margin: 10,
          filename: `invoice_${invoiceId}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        })
        .from(element)
        .save();**/
      setNotification({ open: true, message: 'Invoice downloaded successfully', severity: 'success' });
    } catch (err) {
      console.error('Failed to download invoice:', err);
      setNotification({ open: true, message: 'Failed to download invoice', severity: 'error' });
    }
  };

  // Handle printing invoice
  const handlePrintInvoice = (invoiceId) => {
    setNotification({
      open: true,
      message: 'Preparing invoice for printing',
      severity: 'info'
    });
  };

  // Handle sort click
  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  
  // Re-process invoices when sort configuration changes
  useEffect(() => {
    if (invoicesData.length > 0) {
      processInvoicesData(invoicesData);
    }
  }, [sortConfig, invoicesData, processInvoicesData]);

  // Fetch data on component mount
  useEffect(() => {
    fetchStudentInfo();
    fetchInvoices();
    fetchStudents();
  }, []);

  // Calculate total amounts
  const calculateTotals = (invoices) => {
    if (!Array.isArray(invoices) || invoices.length === 0) {
      return { total: 0, paid: 0, pending: 0, overdue: 0 };
    }
    
    return invoices.reduce(
      (acc, invoice) => {
        acc.total += invoice.amount;
        if (invoice.status.toLowerCase() === 'paid') {
          acc.paid += invoice.amount;
        } else if (invoice.status.toLowerCase() === 'overdue') {
          acc.overdue += invoice.amount;
        } else {
          acc.pending += invoice.amount;
        }
        return acc;
      },
      { total: 0, paid: 0, pending: 0, overdue: 0 }
    );
  };

  const totals = calculateTotals(invoicesData);

  // Close notification
  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };


  const handleSavePayment = async () => {
    try {
       const payload = {
      invoiceId: latestInvoice?.id,
      payments: Object.entries(paymentInputs).map(([itemId, amount]) => ({
        item_id: itemId,
        amount_paid: amount,
      })),
    };
      const token = localStorage.getItem("token");

      // 1. Fetch CSRF cookie
      await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });

      // 2. Get CSRF token
      const xsrfToken = getCookie('XSRF-TOKEN');
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }

      const response = await fetch(`${config.API_URL}/api/payInvoice`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-XSRF-TOKEN': xsrfToken,
      },
      credentials: 'include',
      body: JSON.stringify(payload), // Correctly include payload in body
    });

      const text = await response.text();

      if (!response.ok) {
        let message = "Failed to save payment.";
        try {
          const json = JSON.parse(text);
          message = json.message || message;
        } catch (_) {
          if (text) message = text;
        }
        return { success: false, message };
      }

      // Parse only if response body exists
      const data = text ? JSON.parse(text) : {};
      //window.location.assign(`/students/${payload.invoice_id}/viewinvoice`);
      return { success: true, message: data.message || "Payment saved successfully." };
    } catch (error) {
      console.error('Error in handleEditSubmitPayment:', error);
      return { success: false, message: error.message || "Network error." };
    }
  };


   const columns = useMemo(
    () => [
      { name: 'id', label: 'ID' },
       { name: 'payment_reference', label: 'Reference No' },
      { name: 'admission_number', label: 'Admission No' },
      { name: 'name', label: 'Name' },
      { name: 'amount', label: 'Amount' },
      { name: 'created_at', label: 'Paid On' },
      
    ],
    [data]
  );

  const options = useMemo(
    () => ({
      search: false,
      filter: true,
      download: true,
      print: true,
      pagination: true,
      serverSide: true,
      count: total,
      rowsPerPage: rowsPerPage,
      page: page,
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
            setPage(tableState.page);
            break;
          case 'changeRowsPerPage':
            setRowsPerPage(tableState.rowsPerPage);
            setPage(0);
            break;
          default:
            break;
        }
      },
      onRowClick: (rowData, rowMeta) => {
        const student = data[rowMeta.dataIndex];

    window.open(`${config.API_URL}/downloadReceipt/${student.id}/${token}`);
       // navigate(`/students/${student.id}/viewreceipt`);
      },
    }),
    [total, page, rowsPerPage, data, navigate]
  );

  /**const handleSavePayment = () => {
    const payload = {
      invoiceId: latestInvoice?.id,
      payments: Object.entries(paymentInputs).map(([itemId, amount]) => ({
        item_id: itemId,
        amount_paid: amount,
      })),
    };

    axios.post(config.API_URL+'/api/payInvoice', payload, {
      headers: { Authorization: `Bearer ${token_}` },
    })
    .then(response => {
      alert('Payment saved!');
      setShowPaymentModal(false);
      // Optional: Refresh invoice info
    })
    .catch(error => {
      console.error('Payment error:', error);
      alert('Error saving payment.');
    });
  };**/

  // Display skeletons when loading
  if (loading) {
    return (
      <div className="d-flex flex-column" id="kt_app_root">
        <TopBar />
        <div className="d-flex flex-grow-1">
          <SideBar />
          <div className="flex-grow-1 p-4">
            <Box p={3}>
              <Skeleton variant="rectangular" height={50} width="50%" sx={{ mb: 2, borderRadius: '8px' }} />
              <Grid container spacing={3} sx={{ mb: 4 }}>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rectangular" height={160} sx={{ borderRadius: '12px' }} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Skeleton variant="rectangular" height={160} sx={{ borderRadius: '12px' }} />
                </Grid>
              </Grid>
              <Skeleton variant="rectangular" height={40} sx={{ mb: 2, borderRadius: '8px' }} />
              <Skeleton variant="rectangular" height={300} sx={{ borderRadius: '12px' }} />
            </Box>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      `<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
        <CircularProgress />
      </div>`
    );
  }

  // Display error state
  if (error) {
    return (
      <div className="d-flex flex-column" id="kt_app_root">
        <TopBar />
        <div className="d-flex flex-grow-1">
          <SideBar />
          <div className="flex-grow-1 p-4">
            <Alert
              severity="error"
              sx={{
                m: 3,
                borderRadius: '12px',
                bgcolor: '#FFF1F2',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              }}
            >
              Error loading invoices. Please try again later or contact support.
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column" id="kt_app_root" sx={{ minHeight: '100vh' }}>
      <TopBar />
      <div className="d-flex flex-grow-1">
        <SideBar />

        <div className="flex-grow-1 p-4"  >
        <DynamicNav/>
        <Grid item xs={12}>
                      <Divider sx={{ my: 2, bgcolor: '#E2E8F0' }} />
                      <Box display="flex" justifyContent="flex-end" gap={1}>
                        <Tooltip title="Download Invoice">
                          <IconButton
                            color="primary"
                            onClick={() => handleDownloadInvoice(latestInvoice?.id)}
                            sx={{
                              transition: 'transform 0.2s ease',
                              '&:hover': { transform: 'scale(1.1)' },
                            }}
                          >
                            <FileDownload />
                          </IconButton>
                        </Tooltip>
                      {/*  <Tooltip title="Print Invoice">
                          <IconButton
                            color="primary"
                            onClick={() => handlePrintInvoice(latestInvoice?.id)}
                            sx={{
                              transition: 'transform 0.2s ease',
                              '&:hover': { transform: 'scale(1.1)' },
                            }}
                          >
                            <Print />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Send Reminder">
                          <IconButton
                            color="primary"
                            onClick={() => sendReminder(latestInvoice?.id)}
                            disabled={latestInvoice?.status.toLowerCase() === 'paid'}
                            sx={{
                              transition: 'transform 0.2s ease',
                              '&:hover': { transform: 'scale(1.1)' },
                            }}
                          >
                            <Mail />
                          </IconButton>
                        </Tooltip>
                        */}
                        <Button
                          variant="contained"
                          onClick={() => handleEditModal(latestInvoice?.id)}
                          sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            background: 'linear-gradient(45deg, #6B46C1, #3182CE)',
                            color: '#FFFFFF',
                            fontWeight: 500,
                            px: 3,
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              background: 'linear-gradient(45deg, #553C9A, #2B6CB0)',
                            },
                          }}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="contained"
                          startIcon={<Payment />}
                          disabled={latestInvoice?.status.toLowerCase() === 'paid'}
                          onClick={handleMarkPaid}
                          sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            background: 'linear-gradient(45deg, #6B46C1, #3182CE)',
                            color: '#FFFFFF',
                            fontWeight: 500,
                            px: 3,
                            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                              background: 'linear-gradient(45deg, #553C9A, #2B6CB0)',
                            },
                          }}
                        >
                          Add Payment
                        </Button>
                        <PaymentModal
                          open={modalOpen}
                          onClose={handleModalClose}
                          invoice={latestInvoice?.id}
                          invoiceItems={getInvoiceItems}
                          accounts={accounts}
                          onSubmit={handleSubmitPayment}
                        />
                        <EditInvoiceModal
                          open={modalEditOpen}
                          onClose={handleEditModalClose}
                          invoice={latestInvoice}
                          invoiceItems={getInvoiceItems}
                          onSubmit={handleEditSubmitPayment}
                        />
                      </Box>
                    </Grid>

          <Box
            p={3}
            ref={invoiceRef}
            sx={{
              bgcolor: 'background.default',
              minHeight: '100vh',
            }}
          >
            {/* Page header with student info */}
            <Box
              display="flex"

              justifyContent="space-between"
              alignItems="center"
              mb={3}
              sx={{ bgcolor: 'background.paper', p: 2, borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
            >
              <Box>
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  gutterBottom
                  sx={{ color: '#2D3748' }}
                >
                Johari School
                <br />
                  Student Invoice
                </Typography>
                {studentInfo && (
                  <Box display="flex" alignItems="center">
                    <Typography
                      variant="h6"
                      sx={{ color: '#718096' }}
                    >
                      {studentInfo.name} - Admission: {studentInfo.admission}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Latest Invoice */}
            {latestInvoice && (
              <Box mb={4}>
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  mb={2}
                  display="flex"
                  alignItems="center"
                  sx={{ color: '#2D3748' }}
                >
                </Typography>
                <Paper
                  elevation={2}
                  // Added ref to Paper
                  sx={{
                    p: 3,
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s ease',
                    '&:hover': { transform: 'translateY(-2px)' },
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Invoice #:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {latestInvoice?.invoiceNumber}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Issue Date:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {formatDate(latestInvoice?.invoiceIssueDate)}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Due Date:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {formatDate(latestInvoice?.invoiceDueDate)}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Amount:
                        </Typography>
                        <Typography variant="body1" fontWeight="bold" sx={{ color: '#2D3748' }}>
                          {formatCurrency(latestInvoice?.invoiceAmount)}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between" mb={2}>
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Status:
                        </Typography>
                        <InvoiceStatus status={latestInvoice?.status} />
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <Typography variant="body1" fontWeight="medium" sx={{ color: '#2D3748' }}>
                          Description:
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#718096' }}>
                          {latestInvoice?.note || "--"}
                        </Typography>
                      </Box>
                    </Grid>
                    {/* Invoice Items Table */}
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        fontWeight="medium"
                        mt={3}
                        mb={2}
                        sx={{ color: '#2D3748' }}
                      >
                        Invoice Items
                      </Typography>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow sx={{ bgcolor: '#F7FAFC' }}>
                              <TableCell sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Description
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Quantity
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Total
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                                Paid
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                               Balance
                              </TableCell>
                              <TableCell align="right" sx={{ fontWeight: 'medium', color: '#2D3748' }}>
                               OverPayment
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {getInvoiceItems.map((item, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  bgcolor: index % 2 === 0 ? '#FFFFFF' : '#F7FAFC',
                                  '&:hover': { bgcolor: '#F0E9FF' },
                                }}
                              >
                                <TableCell sx={{ color: '#2D3748' }}>{item.description}</TableCell>
                                <TableCell align="right" sx={{ color: '#718096' }}>
                                  {item.quantity}
                                </TableCell>
                                <TableCell align="right" sx={{ color: '#2D3748', fontWeight: 'medium' }}>
                                  {formatCurrency(item.total)}
                                </TableCell>
                                <TableCell align="right" sx={{ color: '#718096' }}>
                                  {formatCurrency(item.paid)}
                                </TableCell>
                                <TableCell align="right" sx={{ color: '#718096' }}>
                                  {formatCurrency(item.balance)}
                                </TableCell>
                                 <TableCell align="right" sx={{ color: '#718096' }}>
                                  {formatCurrency(item.excess_amount)}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                          <TableBody>
                            <TableRow>
                              <TableCell align="right" sx={{ color: '#718096' }}></TableCell>
                              <TableCell align="right" sx={{ color: '#718096' }}></TableCell>
                              <TableCell align="right" sx={{ color: '#718096' }}>
                                <Typography
                                  variant="body1"
                                  fontWeight="bold"
                                  sx={{ color: '#2D3748' }}
                                >
                                  Total:{' '}
                                  {formatCurrency(
                                    getInvoiceItems.reduce((sum, item) => sum + item.total, 0)
                                  )}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" sx={{ color: '#718096' }}>
                                <Typography
                                  variant="body1"
                                  fontWeight="bold"
                                  sx={{ color: '#2D3748' }}
                                >
                                  Total:{' '}
                                  {formatCurrency(
                                    getInvoiceItems.reduce((sum, item) => sum + item.paid, 0)
                                  )}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" sx={{ color: '#718096' }}>
                                <Typography
                                  variant="body1"
                                  fontWeight="bold"
                                  sx={{ color: '#2D3748' }}
                                >
                                  Total:{' '}
                                  {formatCurrency(
                                    getInvoiceItems.reduce((sum, item) => sum + item.balance, 0)
                                  )}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" sx={{ color: '#718096' }}>
                                <Typography
                                  variant="body1"
                                  fontWeight="bold"
                                  sx={{ color: '#2D3748' }}
                                >
                                  Total:{' '}
                                  {formatCurrency(
                                    getInvoiceItems.reduce((sum, item) => sum + item.excess_amount, 0)
                                  )}
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <br/><br/>
                      <h3>Invoice Payments</h3>
                      <br/>
                      <hr/>
                      <MUIDataTable title={'Payments'} data={data} columns={columns} options={options} />
     

      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleView}>View</MenuItem>
      </Menu>
                    </Grid>
                   
                  </Grid>
                   
                </Paper>
              </Box>
            )}

            {/* Notification system */}
            <Snackbar
              open={notification.open}
              autoHideDuration={6000}
              onClose={handleCloseNotification}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <Alert
                onClose={handleCloseNotification}
                severity={notification.severity}
                sx={{
                  width: '100%',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                }}
              >
                {notification.message}
              </Alert>
            </Snackbar>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default StudentInvoicesLayout;